import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import { useTenantStore } from './store/tenantStore';
import { initPreviewMode } from './services/previewMode';
import './main.css';

async function bootstrap() {
    const app = createApp(App);
    const pinia = createPinia();

    if (import.meta.env.VITE_SENTRY_DSN) {
        try {
            Sentry.init({
                app,
                dsn: import.meta.env.VITE_SENTRY_DSN,
                integrations: [
                    Sentry.browserTracingIntegration(),
                    Sentry.replayIntegration()
                ],
                tracesSampleRate: 0.2,
                replaysSessionSampleRate: 0.1,
                replaysOnErrorSampleRate: 1.0,
            });
        } catch (e) {
            console.warn('⚠️ [Sentry] Initialization failed (non-blocking):', e.message);
        }
    }

    app.use(pinia);

    // Initialize preview mode if in iframe with ?preview=true
    initPreviewMode();

    // Initialize Tenant Logic BEFORE mounting UI
    // This ensures no components map to 'undefined' tenant
    const tenantStore = useTenantStore();

    // In a real app, we might render a loading spinner here while determining tenant
    await tenantStore.initializeApp();

    if (tenantStore.error) {
        document.body.innerHTML = `<h1>Fatal Error: ${tenantStore.error}</h1>`;
        return;
    }

    app.mount('#app');
}

bootstrap();
